import { render, staticRenderFns } from "./CommunitySettingsIntegrations.vue?vue&type=template&id=371ffd7a&scoped=true&"
import script from "./CommunitySettingsIntegrations.vue?vue&type=script&lang=js&"
export * from "./CommunitySettingsIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ffd7a",
  null
  
)

export default component.exports